import { render } from "./SocialProof.vue?vue&type=template&id=bd907f1e&scoped=true"
import script from "./SocialProof.vue?vue&type=script&lang=js"
export * from "./SocialProof.vue?vue&type=script&lang=js"

import "./SocialProof.vue?vue&type=style&index=0&id=bd907f1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd907f1e"]])

export default __exports__